import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux'

import FavIcon from '../app/FavIcon';
import ClubList from './ClubList';
import DataFetchError from './DataFetchError';

class SelectClubSL extends Component {

  componentDidMount() {
    document.title = `Lid worden bij de ${this.props.unionid}`;
  }
  render() {

    if (this.props.club.failure) {
       return <DataFetchError />
    }

    const unionIdLower = this.props.unionid.toLowerCase();
    return (
        <div className="App ">
          <FavIcon isKNVB={false} />

          <Container fluid={true}>
            <Row className="Header">
              <div className="mx-auto" id="union-logo">
                <img className="UnionLogoClubList img-fluid  float-md-center" src={`/img/${unionIdLower}logo.png`} alt={"logo " + this.props.unionid} />
              </div>
            </Row>

            <Row>
              <Container className="Content ContentWhite">
                <Row>
                   <Col md={{ size: 8,offset: 2 }}>
                     <h1>
                       Lid worden bij de {this.props.unionid}
                     </h1>
                     <p> Leuk dat je lid wilt worden! Kies een vereniging waar jij je thuisvoelt.</p>
                   </Col>
                </Row>

                <Row>
                 <Col md={{ size: 8,offset: 2 }} className="bodyContent" >
                   <ClubList unionid={this.props.unionid} onclick={(club) => {
                      sessionStorage.setItem('ClubId', club);
                      this.props.history.push("/" + this.props.unionid + "/aanmelden");
                     }}  />
                  </Col>
                </Row>
              </Container>
            </Row>
            <Row>
              <div className="ml-auto">
                <img className="sl-logo" src="/img/sportlink_logo.png" alt="Sportlink logo" />
              </div>
            </Row>

          </Container>
        </div>
    );
  }
}


const mapStateToProps = state => ({
  club: state.club
})


export default connect(
  mapStateToProps
)(SelectClubSL)



// WEBPACK FOOTER //
// ./src/club/SelectClubSL.jsx